// HC-BLOCK-001 (Apple 1.2, Prompt #278). Retroactive hide — a blocked
// sender's messages, however old, never render for the blocker. Extracted
// as a pure function (same "extract for testability" precedent as
// resolveMarkAsReadRefire.js/chatTranslationDisplay.js in this file) so
// it's directly unit-testable without ChatRoomPage's full Firebase-backed
// component. Mirrors mobile's identical filterBlockedMessages
// (mobile/lib/features/chat/utils/chat_message_visibility.dart) — same
// logic, independently ported (no Dart<->JS interop in this repo).
export function filterBlockedMessages(messages, blockedUserIds) {
  if (!blockedUserIds || blockedUserIds.length === 0) return messages;
  const blocked = new Set(blockedUserIds);
  return messages.filter((m) => !blocked.has(m.senderId));
}
